import { buildScopedI18n } from '../../utils/buildScopedI18n';
import mineEsCL from './locales/es-CL.json';
import mineEnUS from './locales/en-US.json';
import minePtBR from './locales/pt-BR.json';

export const escriturasMineI18n = buildScopedI18n({
  esCL: mineEsCL,
  enUS: mineEnUS,
  ptBR: minePtBR,
});
